import * as React from "react";
import { z } from "zod";
import styled from "styled-components";
import { CarouselSlides, CarouselViewport, CarouselProgressBar, CarouselControls, Carousel, CarouselPrevious, CarouselNext, } from "../../../components/Carousel";
import { Blade } from "../../../components/Blade";
import { ArticleCardSlide } from "..";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { ContentListBladeSchema } from "../../../schemas/blades/ContentList";
import { Backdrop, BackdropBackground, BackdropForeground } from "../../../components/Backdrop";
import { Media } from "../../../components/Media";
import { hasVisibleContent } from "../../../functional/showBladeHeader";
import { AnalyticsProvider } from "../../../providers/AnalyticsProvider";
import { CTA } from "../../../components/CTA";
import { BladeContent } from "../../../components/BladeContent";
import { lionSkin } from "../skins/project-l";
export const ArticleCardCarouselContractSchema = ContentListBladeSchema.extend({
    type: z.literal("articleCardCarousel"),
});
const _ArticleCardCarousel = ({ backdrop, header, items, ...props }) => {
    const headerContent = hasVisibleContent(header);
    const { background, foreground } = backdrop || {};
    const { title, links } = header || {};
    const link = links?.[0];
    return (React.createElement(Blade, { "data-testid": "article-card-carousel", ...props },
        React.createElement(BladeContent, { width: "large" },
            React.createElement(Backdrop, null,
                React.createElement(BackdropBackground, null, background && React.createElement(Media, { media: background, role: "presentation" })),
                React.createElement(BackdropForeground, null, foreground && React.createElement(Media, { media: foreground, role: "presentation" }))),
            header && headerContent && (React.createElement("div", { className: "header" },
                title && React.createElement("h2", { "data-testid": "title" }, title),
                link && React.createElement(CTA, { variant: "tertiary", ...link }))),
            React.createElement(AnalyticsProvider, { uiLocation: "carousel" },
                React.createElement(Carousel, { draggable: true },
                    React.createElement(CarouselViewport, null,
                        React.createElement(CarouselSlides, null, items.map((item, index) => {
                            return React.createElement(ArticleCardSlide, { content: item, slideIndex: index, slideTotal: items.length, key: index });
                        }))),
                    React.createElement(CarouselControls, null,
                        React.createElement(CarouselProgressBar, null),
                        React.createElement("div", { className: "trigger-wrapper" },
                            React.createElement(CarouselPrevious, null),
                            React.createElement(CarouselNext, null))))))));
};
export const ArticleCardCarousel = styled(_ArticleCardCarousel) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
    [SkinId.RiotProductLion]: lionSkin,
})}
`;
//# sourceMappingURL=ArticleCardCarousel.js.map